module.exports = __webpack_public_path__ + "static/img/8.93861fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/eng/8.png
// module id = +RiC
// module chunks = 0